// interactjs lets us drag and drop
import interact from 'interactjs'

// air-datepicker lets us choose a date for the archive
import AirDatepicker from "air-datepicker";
import AirDatepickerLocaleEn from "air-datepicker/locale/en";
import "air-datepicker/air-datepicker.css";

// gameDate we are currently playing
let gameDate = null;
let localStorageCurrentGameDateKey = 'current-game-date';
let localStorageSpecialTodayValue = 'today';

let divIdPrefix = 'drag-';

let positions = {};

let dragHintShown = true;

// store the color picker tile ID currently acting on
let colorPickerTileId = null;

// tracks whether the tile is moving so we can prevent accidental color taps
let tileIsMoving = false;

// tracks whether it's ok to dismiss the color picker dialog (which might get a click event by accident)
let colorPickerDialogDismissPrevent = false;

// global dialogs
let colorPickerDialog;
let settingsDialog;
let howToDialog;
let howToInstallDialog;

// gets the data then sends the data to buildpage function
document.addEventListener("DOMContentLoaded", function(){
    init();
});

/** And now, some functions */

function hideDragHintIfShown() {
    if (dragHintShown) {
        document.getElementById('drag-hint').style.display = 'none';
        dragHintShown = false;
    }
}

function checkTodaysDateDoesntMatchGame() {
    // find out if we're playing an archive game or if we're playing today's game
    let localStorageCurrentGameDate = localStorage.getItem(localStorageCurrentGameDateKey);

    // not playing an archive game and the current day doesn't equal the game day, let's reload
    if (getGameDateFormatted(new Date()) != gameDate && localStorageCurrentGameDate == localStorageSpecialTodayValue) {
        window.location.reload();
    }
}

// move the elements according to the x and y
function setTransform(element, x, y) {
    element.style.transform = `translate(${x}px, ${y}px)`
}

function buildWordsFromStartingGroups(startingGroups) {
    let words = [];

    for (let i = 0; i < startingGroups.length; i++) {
        for (let j = 0; j < startingGroups[i].length; j++) {
            words.push(startingGroups[i][j]);
        }
    }

    return words;
}

function getGameDateFormatted(date) {
    return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
}

function getMonthFormatted(date){
    return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0');
}

function renderGameDateInLocale(gameDate) {
    let suffix = '';
    if (gameDate == getGameDateFormatted(new Date())) {
        suffix = ' (today)';
    }
    else {
        suffix = ' (archive)';
    }

    return convertGameDateToDate(gameDate).toLocaleDateString() + suffix;
}

function convertGameDateToDate(gameDate) {
    let parts = gameDate.split('-');
    let year = parseInt(parts[0]);
    // month is zero-based
    let month = parseInt(parts[1]) - 1;
    let day = parseInt(parts[2]);
    return new Date(year, month, day);
}

function persistPositions() {
    localStorage.setItem(gameDate, JSON.stringify(positions));
}

function addColorToTile(tile, color) {
    tile.classList.remove('tile-color-yellow');
    tile.classList.remove('tile-color-blue');
    tile.classList.remove('tile-color-green');
    tile.classList.remove('tile-color-purple');
    tile.classList.remove('tile-color-gray');
    tile.classList.remove('tile-color-none');

    tile.classList.add('tile-color-' + color);
}

function init() {
    // find out if we're playing an archive game or if we're playing today's game
    let localStorageCurrentGameDate = localStorage.getItem(localStorageCurrentGameDateKey);

    // haven't chosen a game date or it's today
    if (!localStorageCurrentGameDate || localStorageCurrentGameDate == localStorageSpecialTodayValue) {
        gameDate = getGameDateFormatted(new Date());
        localStorage.setItem(localStorageCurrentGameDateKey, localStorageSpecialTodayValue);
    }
    else {
        gameDate = localStorageCurrentGameDate;
    }

    let localStorageGameKey = `game-${gameDate}`;

    // does the game exist already? don't fetch the data from the endpoint
    let localStorageGame = localStorage.getItem(localStorageGameKey);
    if (localStorageGame) {
        buildPage(JSON.parse(localStorageGame));
    }
    // Don't have the data, need to fetch the data freshfresh
    else {
        // NYT game url
        let url = 'https://www.nytimes.com/svc/connections/v1/' + gameDate + '.json';

        let workerUrl = 'https://connections-json-cors.matt-mendick.workers.dev/?url=' + encodeURIComponent(url);

        fetch(workerUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok: ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                // cache
                localStorage.setItem(localStorageGameKey, JSON.stringify(data));
                return data;
            })
            .then(data => buildPage(data))
            .catch(error => {
                console.error('Error fetching data:', error);
                if (window.confirm("There was an error fetching the game data. Reload?")) {
                    window.location.reload();
                }
            });
    }

    /** Settings dialog/buttons **/
    settingsDialog = document.getElementById('settings');
    let settingsButton = document.getElementById('settings-button');
    let closeSettingsButton = document.getElementById('close-settings-button');

    settingsButton.addEventListener("click", () => {
        settingsDialog.showModal();
        faro.api.pushEvent('User opened settings dialog');
    });

    closeSettingsButton.addEventListener("click", () => {
        settingsDialog.close();
    });

    settingsDialog.addEventListener('click', event => {
        if (event.target === settingsDialog) {
            settingsDialog.close();
        }
    });

    /** How to play game dialog/buttons **/
    howToDialog = document.getElementById('how-to');
    let howToButton = document.getElementById('how-to-button');
    let closeHowToButton = document.getElementById('close-how-to-button');

    howToButton.addEventListener("click", () => {
        howToDialog.showModal();
        faro.api.pushEvent('User opened about dialog');
    });

    closeHowToButton.addEventListener("click", () => {
        howToDialog.close();
    });

    howToDialog.addEventListener('click', event => {
        if (event.target === howToDialog) {
            howToDialog.close();
        }
    });

    /** How to install dialog/buttons **/
    // show the installation instructions if it's not installed
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && window.navigator.standalone == false) {
        document.getElementById('how-to-install-offer').style.display = '';
    }

    howToInstallDialog = document.getElementById('how-to-install');
    let howToInstallButton = document.getElementById('how-to-install-button');
    let closeHowToInstallButton = document.getElementById('close-how-to-install-button');

    howToInstallButton.addEventListener("click", () => {
        howToInstallDialog.showModal();
        howToDialog.close();
    });

    closeHowToInstallButton.addEventListener("click", () => {
        howToInstallDialog.close();
    });

    howToInstallDialog.addEventListener('click', event => {
        if (event.target === howToInstallDialog) {
            howToInstallDialog.close();
        }
    });

    /** Color picker dialog/buttons **/
    colorPickerDialog = document.getElementById('color-picker');
    let closeColorPickerButton = document.getElementById('close-color-picker-button');

    closeColorPickerButton.addEventListener("click", () => {
        colorPickerDialog.close();
    });

    colorPickerDialog.addEventListener('click', event => {
        if (event.target === colorPickerDialog) {
            if (colorPickerDialogDismissPrevent) {
                return;
            }
            colorPickerDialog.close();
        }
    });

    // set up the date picker
    let options = {
        locale: AirDatepickerLocaleEn,
        isMobile: true,
        autoClose: true,
        buttons: [
            {
                content: `Today`,
                onClick: (picker) => {
                    picker.selectDate(new Date());
                }
            }
        ],
        dateFormat: (date) => {
            let suffix = '';
    
            if (gameDate == getGameDateFormatted(new Date())) {
                suffix = ' (today)';
            }
            else {
                suffix = ' (archive)';
            }

            return convertGameDateToDate(gameDate).toLocaleDateString() + suffix;
        },
        onShow: (isFinishedShowing) => {
            // fires twice, only fire after it's done
            if(isFinishedShowing){
                return;
            }

            settingsDialog.close();
        },
        onHide: (isFinishedShowing) => {
            // fires twice, only fire after it's done
            if(isFinishedShowing){
                return;
            }

            settingsDialog.showModal();
        },
        onRenderCell: ({date}) => {
            let html = '';
            let disabled = false;

            // disable dates before the earliest date the NYT has games
            const earliestDate = new Date('2023-06-12T00:00:00');
            const today = new Date();
            const todayAtMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const dateNumber = date.getDate().toString();

            if (date.getTime() < earliestDate.getTime() || date.getTime() > todayAtMidnight.getTime()) {
                disabled = true;
                let imgSrc = new URL('./no-game-dot.svg', import.meta.url);
                html = `<div style="font-size: 13px;"><img class="svg-icon" width="16px" height="16px" src="${imgSrc.href}" /><br \>${dateNumber}</div>`;
            }
            else {
                if (dateHasGameData(date)) {    
                    let imgSrc = new URL('./logo-with-box.svg', import.meta.url);
                    html = `<div style="font-size: 13px;"><img class="svg-icon" width="16px" height="16px" src="${imgSrc.href}" /><br \>${dateNumber}</div>`;
                }
                else {
                    let imgSrc = new URL('./b-and-w-logo.svg', import.meta.url);
                    html = `<div style="font-size: 13px;"><img class="svg-icon" width="16px" height="16px" src="${imgSrc.href}";" /><br \>${dateNumber}</div>`;
                }
            }

            return {
                html: html,
                disabled: disabled
            }
        },
        onSelect: (selected) => {
            // if you select today's date it'll be undefined, so let's just make it today
            if (!selected.date){
                selected.date = new Date();
            }

            let formattedDate = getGameDateFormatted(selected.date);

            // if they have chosen today's date, lock them onto "today"
            if(formattedDate == getGameDateFormatted(new Date())){
                formattedDate = localStorageSpecialTodayValue;   
            }

            localStorage.setItem(localStorageCurrentGameDateKey, formattedDate);

            faro.api.pushEvent('User accessed archive game');

            window.location.reload();
        },
        selectedDates: [convertGameDateToDate(gameDate)]
    };
      
    let datePicker = new AirDatepicker("#archive-game-date-picker-hidden", options);

    // render the current date to the archive-game-date-picker-hidden
    document.getElementById('current-game-date-display').innerHTML = renderGameDateInLocale(gameDate);

    // if the date is not today, we should highlight that it's an archive game
    if (gameDate != getGameDateFormatted(new Date())) {
        setTimeout(function () {
            document.getElementById('current-game-date-display').classList.add('item-highlight');
        }, 500);
    }

    // make the date at the bottom of the screen clickable
    document.getElementById('current-game-date-display').addEventListener("click", () => {
        settingsDialog.showModal();
        faro.api.pushEvent('User opened settings dialog');
    });

    // render the current date to the archive-game-date in the settings dialog
    document.getElementById('archive-game-date').innerHTML = renderGameDateInLocale(gameDate);

    // make the whole settings cell clickable
    document.getElementById('archive-game-date-click-container').addEventListener("click", () => {
        datePicker.show();
    });
}

function dateHasGameData(date) {
    let formattedDate = getGameDateFormatted(date);

    if(localStorage.getItem(`${formattedDate}`)){
        return true;
    }

    return false;
}

function buildPage(data) {

    let words = buildWordsFromStartingGroups(data.startingGroups);

    let container = document.getElementById('container');

    // get rid of the loader
    container.innerHTML = '';
    container.className = 'flex-container container-without-loader';

    // let's make the boxes in a nice grid
    for (let i = 0; i < words.length; i++) {
        let div = document.createElement("div");
        div.className = "draggable";
        div.id = divIdPrefix + i;

        let content = document.createElement("div");
        div.appendChild(content);
        container.appendChild(div);
        positions[div.id] = { x: null, y: null, color: 'none' };
    }

    let finishLayingOutPage = () => {
        // now assign the words to them and make sure the text inside doesn't make the box a different size
        // this all happens quickly enough that we don't need to worry about the user seeing the text change
        for (let i = 0; i < words.length; i++) {
            let element = document.getElementById(divIdPrefix + i);

            let originalRect = element.getBoundingClientRect();
            element.textContent = words[i];
            let startingFontSize = 15;
            let elementFontSize = startingFontSize;

            while (true) {
                element.style.fontSize = elementFontSize + 'px';
                let afterRect = element.getBoundingClientRect();
                if (afterRect.width != originalRect.width || afterRect.height != originalRect.height) {
                    elementFontSize -= 0.5;
                    continue;
                }
                else {
                    // fake a little padding
                    elementFontSize -= 1.0;
                    element.style.fontSize = elementFontSize + 'px';
                    break;
                }
            }
        }

        interact('.draggable').draggable({
            listeners: {
                start(event) {
                    //console.log(event.type, event.target)
                },
                move(event) {
                    tileIsMoving = true;
                    hideDragHintIfShown();
                    positions[event.target.id].x += event.dx
                    positions[event.target.id].y += event.dy

                    setTransform(event.target, positions[event.target.id].x, positions[event.target.id].y);

                    persistPositions();
                },
                end(event) {
                    setTimeout(function () {
                        tileIsMoving = false;
                    }, 100);
                }
            }
        })

        interact('.draggable').on('tap', function (event) {
            if (tileIsMoving) {
                return;
            }
            colorPickerTileId = event.currentTarget.id;
            colorPickerDialogDismissPrevent = true;
            colorPickerDialog.showModal();
            setTimeout(function () {
                colorPickerDialogDismissPrevent = false;
            }, 100);
        });

        interact('.color-picker-button').on('tap', function (event) {
            if (colorPickerDialogDismissPrevent) {
                return;
            }
            let color = event.currentTarget.dataset.color;
            let tile = document.getElementById(colorPickerTileId);
            addColorToTile(tile, color);
            positions[colorPickerTileId].color = color;
            colorPickerTileId = null;
            persistPositions();
            colorPickerDialog.close();
        });

        document.getElementById('reset-current').onclick = function () {
            if (window.confirm("Really reset the position of the boxes and colors for the current game?")) {
                localStorage.removeItem(gameDate);
                window.location.reload();
            }
        };

        document.getElementById('reset-all').onclick = function () {
            if (window.confirm("Really reset all data? This resets all tile position and color data for all games.")) {
                localStorage.clear();
                window.location.reload();
            }
        };

        let storedPositions = localStorage.getItem(gameDate);
        if (storedPositions) {
            // If we do, use them
            positions = JSON.parse(storedPositions);

            for (let i = 0; i < words.length; i++) {
                let divId = divIdPrefix + i;
                let element = document.getElementById(divId);
                if (positions[divId].x != null && positions[divId].y != null) {
                    setTransform(element, positions[divId].x, positions[divId].y);
                }

                addColorToTile(element, positions[divId].color);
            }

            hideDragHintIfShown();
        }

        // if the date is not today
        setInterval(function () {
            checkTodaysDateDoesntMatchGame();
        }, 60000);

        window.onfocus = function () {
            checkTodaysDateDoesntMatchGame();
        }
    };

    // this is _nuts_ but sometimes the tiles don't have the right in-DOM size right away, so try it first
    // and then if it isn't right, try again in 10ms
    let canFinishLayingOutPageCounter = 0;
    let canFinishLayingOutPage = () => {
        // if we can't finish laying out the page after 500ms, just give up
        if(canFinishLayingOutPageCounter > 50){
            console.error('Could not finish laying out page, try it anyway');
            finishLayingOutPage();
            return;
        }
        let element = document.getElementById(divIdPrefix + '0');

        let originalRect = element.getBoundingClientRect();
        if (originalRect.width != originalRect.height) {
            canFinishLayingOutPageCounter++;
            setTimeout(canFinishLayingOutPage, 10);
        }
        else {
            finishLayingOutPage();
        }
    };
    canFinishLayingOutPage();
}



/** Grafana Faro/Frontend Telemetry */
(function () {
    var webSdkScript = document.createElement("script");

    // fetch the latest version of the Web-SDK from the CDN
    webSdkScript.src =
        "https://unpkg.com/@grafana/faro-web-sdk@^1.4.0/dist/bundle/faro-web-sdk.iife.js";

    webSdkScript.onload = () => {
        window.GrafanaFaroWebSdk.initializeFaro({
            url: "https://faro-collector-prod-us-central-0.grafana.net/collect/5849ed034d409495951404a778e3d790",
            app: {
                name: "Connections Copilot",
                version: "1.0.0",
                environment: "production",
            },
        });

        // Load instrumentations at the onLoad event of the web-SDK and after the above configuration.
        // This is important because we need to ensure that the Web-SDK has been loaded and initialized before we add further instruments!
        var webTracingScript = document.createElement("script");

        // fetch the latest version of the Web Tracing package from the CDN
        webTracingScript.src =
            "https://unpkg.com/@grafana/faro-web-tracing@^1.4.0/dist/bundle/faro-web-tracing.iife.js";

        // Initialize, configure (if necessary) and add the the new instrumentation to the already loaded and configured Web-SDK.
        webTracingScript.onload = () => {
            window.GrafanaFaroWebSdk.faro.instrumentations.add(
                new window.GrafanaFaroWebTracing.TracingInstrumentation()
            );

            // let's log the page load once per day
            let localStorageDailyPageLoadDateKey = 'daily-page-load-date';
            let localStorageDailyPageLoadDate = localStorage.getItem(localStorageDailyPageLoadDateKey);
            let todaysActualDate = getGameDateFormatted(new Date());

            // log page load if we haven't logged it for today
            if(!localStorageDailyPageLoadDate || localStorageDailyPageLoadDate != todaysActualDate){    

                // determine if the site is loaded as an app or not
                if (window.navigator.standalone == true) {
                    faro.api.pushEvent('User daily page load event as app');
                }
                else {
                    faro.api.pushEvent('User daily page load event as web');
                }
                
                faro.api.pushLog([`User daily page load`], {
                    context: {
                        date: todaysActualDate
                    },
                    level: 'info'
                });

                localStorage.setItem(localStorageDailyPageLoadDateKey, todaysActualDate);
            }

            // let's log the page load once per month
            let localStorageMonthlyPageLoadDateKey = 'monthly-page-load-date';
            let localStorageMonthlyPageLoadDate = localStorage.getItem(localStorageMonthlyPageLoadDateKey);
            let todaysActualMonth = getMonthFormatted(new Date());

            // log page load if we haven't logged it for this month
            if(!localStorageMonthlyPageLoadDate || localStorageMonthlyPageLoadDate != todaysActualMonth){

                // determine if the site is loaded as an app or not
                if (window.navigator.standalone == true) {
                    faro.api.pushEvent('User monthly page load event as app');
                }
                else {
                    faro.api.pushEvent('User monthly page load event as web');
                }

                faro.api.pushLog([`User monthly page load`], {
                    context: {
                        month: todaysActualMonth
                    },
                    level: 'info'
                });

                localStorage.setItem(localStorageMonthlyPageLoadDateKey, todaysActualMonth);
            }
        };

        // Append the Web Tracing script script tag to the HTML page
        document.head.appendChild(webTracingScript);
    };

    // Append the Web-SDK script script tag to the HTML page
    document.head.appendChild(webSdkScript);
})();